import React from 'react';
import texts from '../content/texts';

const OurStory = () => {
    // Funzione per formattare il contenuto sostituendo \n con <br />
    const formatContent = (content) => {
        return content.replace(/\n/g, '<br />');
    };

    return (
        <section>
            <div id="story" className="story-section">
                <span className="line"></span> {/* Linea separatrice */}
                <h2 className="story-title font-detail">La Nostra Storia</h2>        
                <div className="content-wrapper">
                    <div className="left-section-1">
                        <span className="label font uppercase bold">{texts.firstMilestone.title}</span>
                        <div className="story-date font uppercase">{texts.firstMilestone.date}</div>
                        <span className="font-detail" dangerouslySetInnerHTML={{ __html: formatContent(texts.firstMilestone.content) }} />
                    </div>
                    <div className="right-section-1">
                        <img className="rounded-image laurea"/>
                    </div>
                </div>
                <div className="content-wrapper">
                    <div className="left-section-2">
                        <img className="rounded-image transfer"/>
                    </div>
                    <div className="right-section-2">
                        <span className="label font uppercase bold">{texts.transfers.title}</span>
                        <div className="story-date font uppercase">{texts.transfers.date}</div>
                        <span className="font-detail" dangerouslySetInnerHTML={{ __html: formatContent(texts.transfers.content) }} />
                    </div>
                </div>
                <div className="content-wrapper">
                    <div className="left-section-1">
                        <span className="label font uppercase bold">{texts.proposal.title}</span>
                        <div className="story-date font uppercase">{texts.proposal.date}</div>
                        <span className="font-detail" dangerouslySetInnerHTML={{ __html: formatContent(texts.proposal.content) }} />
                    </div>
                    <div className="right-section-1">
                        <img className="rounded-image proposta"/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurStory;